// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:ds:64fOIK */\n.AXPMR{list-style:none;margin:0;padding:0;position:relative;width:100%}._0Z_MV{border-radius:var(--audio-radius-pill);bottom:0;height:24px;overflow:hidden;position:absolute;transform:translateX(-50%);width:24px}.CGyT8{display:block;height:100%;width:100%}.tQlJ2{height:24px;position:relative;width:24px}.W-Bd3{height:24px;width:24px}._7KKP9{align-items:center;background-color:var(--audio-overlay-on-image-default);border-radius:var(--audio-radius-pill);bottom:var(--audio-spacing-2);display:flex;justify-content:center;left:var(--audio-spacing-2);pointer-events:none;position:absolute;right:var(--audio-spacing-2);top:var(--audio-spacing-2)}.U8xss{color:var(--audio-content-primary);font-size:var(--audio-font-size-10);line-height:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": "AXPMR",
	"item": "_0Z_MV",
	"link": "CGyT8",
	"marker": "tQlJ2",
	"avatar": "W-Bd3",
	"badge": "_7KKP9",
	"badgeCount": "U8xss"
};
export default ___CSS_LOADER_EXPORT___;
